import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner } from "@material-tailwind/react";
import { Pagination, SearchAndAddBtn, Dropdowns, THead } from '../../Components';
import { get_feedback_DropDownList, get_feedback, get_user_feedback } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { TbLayout2 } from 'react-icons/tb';
import { AiOutlineAndroid } from 'react-icons/ai';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DatePicker, Space } from 'antd';
import { IoMdDownload } from "react-icons/io";
import { MdFileDownloadOff } from "react-icons/md";
import Tooltip from '@mui/material/Tooltip';
const { RangePicker } = DatePicker;




export const Users = ({ title }) => {
    const { permissions, tokenType, setDeleteUpdateTag, capitalalizeFirstletter, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, isAscending, sortData, selectedDates } = useContext(NewContext);
    const simpleFields = [
        { name: "App", sortable: false, field: 'appName' },
        { name: "Version", sortable: false, field: 'appVersion' },
        { name: "DeviceId", sortable: false, field: 'DeviceId' },
        { name: "Date", sortable: false, field: 'createdAt' },
        { name: "File Uploaded Date", sortable: false, field: 'feedbackFileUploadedDate' },
        { name: "Encrypted File", sortable: false, field: 'encryptedFile' },
        { name: "Decrypted File", sortable: false, field: 'decryptedFile' },
    ];
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    const dropdownFields = [{}];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const [appNamelist, setAppNamelist] = useState([]);
    const [version, setVersion] = useState([]);
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipId, setTooltipId] = useState();

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Users');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])

    useEffect(() => {
    }, [pagePermissions])


    const DropDownList = async () => {
        const DropDownData = await get_feedback_DropDownList();
        DropDownData?.data?.appName?.map(_ele => setAppNamelist(_prev => !appNamelist.includes(_prev) && [..._prev, { id: _ele._id, label: capitalalizeFirstletter(_ele) }]))
        DropDownData?.data?.appVersion?.map(_ele => setVersion(_prev => !version.includes(_prev) && [..._prev, { id: _ele._id, label: capitalalizeFirstletter(_ele) }]))
    }
    useEffect(() => {
        DropDownList();
    }, [])

    const FilterDropdowns = ({ appNamelist, version, }) => {
        return (
            <div className='flex gap-2.5'>
                <Dropdowns title={`Application`} name={`appName`} Icon={TbLayout2} dropData={appNamelist} />
                <Dropdowns title={`Version`} name={`version`} Icon={AiOutlineAndroid} dropData={version} />
            </div>

        )
    }

    const getuserfeedbackData = async (_currentPage = 1, sortName = sortData, sortType = isAscending, startDate, endDate) => {
        setIsLoading(true);
        try {
            const getUserfeedback = await get_user_feedback(_currentPage, perPage, search, filterDropdown, sortName, sortType, startDate, endDate);
            if (getUserfeedback) {
                const { status, data, currentPage, perPage, totalPage } = getUserfeedback;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                } else {
                    setCurrentPageData([]);
                    setTotalPage(0);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }
    useEffect(() => {
        const [startDate, endDate] = selectedDates;
        getuserfeedbackData(currentPage, sortData, isAscending, startDate, endDate);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown, pagePermissions, sortData, isAscending, selectedDates]);

    useEffect(() => {
        document.title = title;
    }, [title])

    const downloadFile = async (url, fileName) => {
        const response = await fetch(url, { method: 'GET', mode: 'cors' });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        const extention = url.split('.')[url.split('.').length - 1]
        link.download = `${fileName}.${extention}`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    }


    return (
        <>
            <SearchAndAddBtn title={`Users`} addBtn={false} datePicker={true} FilterDropdowns={<FilterDropdowns appNamelist={appNamelist} version={version} />} />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <table className="w-full min-w-max table-auto text-center ">
                        <THead simpleFields={simpleFields} isSelectAll={false} actionField={false} />
                        <tbody>
                            {
                                isLoading ?
                                    <tr>
                                        <td colSpan={totalFields} className='py-12'>
                                            <div className="flex justify-center items-center">
                                                <Spinner />
                                            </div>
                                        </td>
                                    </tr>
                                    : currentPageData?.length === 0 ?
                                        <tr>
                                            <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                <div className="flex justify-center items-center">
                                                    No Data Found
                                                </div>
                                            </td>
                                        </tr>
                                        : currentPageData?.map((_ele, i) => {
                                            const isLast = i === currentPageData?.length - 1;
                                            const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;
                                            return (
                                                <tr key={i} className='border-b border-blue-gray-50 '>

                                                    <td className={classes}>
                                                        <div className="flex justify-center items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele?.appName && !_ele?.userId?.appName && `text-gray-500`}`}>{_ele?.appName ? _ele?.appName : _ele?.userId?.appName ? _ele?.userId?.appName : `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex justify-center items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele?.appVersion && !_ele?.userId?.appVersion && `text-gray-500`}`}>{_ele?.appVersion ? _ele?.appVersion : _ele?.userId?.appVersion ? _ele?.userId?.appVersion : `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex justify-center items-center">
                                                            <span className={`font-normal text-[17px] ${!_ele?.deviceId && !_ele?.userId?.deviceId && `text-gray-500`}`}>{_ele?.deviceId ? _ele?.deviceId : _ele?.userId?.deviceId ? _ele?.userId?.deviceId : `None`}</span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex justify-center items-center">
                                                            <span className={`font-normal text-[17px] ${(!_ele?.createdAt && !_ele?.userId?.createdAt) ? 'text-gray-500' : ''}`}>
                                                                {
                                                                    _ele?.createdAt ?
                                                                        moment(_ele?.createdAt).format('DD/MM/YYYY, hh:mm A') :
                                                                        (_ele?.userId?.createdAt ? moment(_ele?.userId?.createdAt).format('DD/MM/YYYY, hh:mm A') : 'None')
                                                                }
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className={classes}>
                                                        <div className="flex justify-center items-center">
                                                            <span className={`font-normal text-[17px] ${(!_ele?.feedbackFileUploadedDate && !_ele?.userId?.feedbackFileUploadedDate) ? 'text-gray-500' : ''}`}>
                                                                {
                                                                    _ele?.feedbackFileUploadedDate ?
                                                                        moment(_ele?.feedbackFileUploadedDate).format('DD/MM/YYYY, hh:mm A') :
                                                                        (_ele?.userId?.feedbackFileUploadedDate ? moment(_ele?.userId?.feedbackFileUploadedDate).format('DD/MM/YYYY, hh:mm A') : 'None')
                                                                }
                                                            </span>
                                                        </div>
                                                    </td>
                                                    {
                                                        _ele?.userFeedbackEncryptedJson ?
                                                            <td className={`${classes} cursor-pointer`}>
                                                                <div className="flex justify-center items-center">
                                                                    <Tooltip title="Download">
                                                                        <IoMdDownload onClick={() => {
                                                                            downloadFile(_ele?.userFeedbackEncryptedJson, _ele?.deviceId || _ele?.userId?.deviceId);
                                                                            setShowTooltip(true);
                                                                        }} />
                                                                    </Tooltip>
                                                                </div>
                                                            </td>
                                                            : <td className={`${classes}`}>
                                                                <div className="flex justify-center items-center">
                                                                    <Tooltip title="Not Download">
                                                                        {'-'}
                                                                    </Tooltip>
                                                                </div>
                                                            </td>
                                                    }

                                                    {
                                                        _ele?.userFeedbackDecryptedJson ?
                                                            <td className={`${classes} cursor-pointer`}>
                                                                <div className="flex justify-center items-center">
                                                                    <Tooltip title="Download">
                                                                        <IoMdDownload onClick={() => {
                                                                            downloadFile(_ele?.userFeedbackDecryptedJson, _ele?.deviceId || _ele?.userId?.deviceId);
                                                                            setShowTooltip(true);
                                                                        }} />
                                                                    </Tooltip>
                                                                </div>
                                                            </td>
                                                            : <td className={`${classes}`}>
                                                                <div className="flex justify-center items-center">
                                                                    <Tooltip title="Not Download">
                                                                        {'-'}
                                                                    </Tooltip>
                                                                </div>
                                                            </td>
                                                    }
                                                </tr>
                                            );
                                        })
                            }
                        </tbody>
                    </table>
                </CardBody>
            </Card >
            {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getuserfeedbackData} />
            }
        </>
    )
}
Users.defaultProps = {
    title: "Message | Users"
};

export default Users
